import { render, staticRenderFns } from "./ArticleStockTable.vue?vue&type=template&id=df7acc7a&scoped=true&"
import script from "./ArticleStockTable.vue?vue&type=script&lang=js&"
export * from "./ArticleStockTable.vue?vue&type=script&lang=js&"
import style0 from "./ArticleStockTable.vue?vue&type=style&index=0&id=df7acc7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df7acc7a",
  null
  
)

export default component.exports